import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c214a6c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Rinnova la tua iscrizione", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Per completare il rinnovo è necessario effettuare il bonifico bancario della quota sopra indicata al beneficiario:", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"margin-bottom":"5px","margin-top":"5px"} }, "AICA - Associazione Italiana per l’Informatica ed il Calcolo Automatico", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"margin-bottom":"5px","margin-top":"5px"} }, "P.le Rodolfo Morandi 2 – 20121 Milano", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"margin-bottom":"5px","margin-top":"5px"} }, " c/o Gruppo bancario Crédit Agricole Italia Piazza San Fedele, 4 - 20121 MILANO", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"margin-bottom":"5px","margin-top":"5px"} }, "IBAN: IT21J0623001633000015087944", -1))
const _hoisted_7 = {
  key: 5,
  id: "paypal-button-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_back_button = _resolveComponent("ion-back-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_text = _resolveComponent("ion-text")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_radio = _resolveComponent("ion-radio")!
  const _component_ion_radio_group = _resolveComponent("ion-radio-group")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_header, { translucent: true }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_toolbar, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_buttons, { slot: "start" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_back_button, { "default-href": "/news" })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_title, null, {
                    default: _withCtx(() => [
                      _createTextVNode("Rinnovo iscrizione")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (_ctx.user)
            ? (_openBlock(), _createBlock(_component_ion_list, { key: 0 }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_text, null, {
                        default: _withCtx(() => [
                          _hoisted_1
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Anno di riferimento")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_label, { slot: "end" }, {
                        default: _withCtx(() => [
                          _createElementVNode("strong", null, _toDisplayString($options.getYearRef), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Quota")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_label, { slot: "end" }, {
                        default: _withCtx(() => [
                          _createElementVNode("strong", null, _toDisplayString($options.getQuota) + "€", 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_item, { lines: "none" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Modalità di pagamento")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_radio_group, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_item, { lines: "none" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_radio, {
                            justify: "start",
                            class: "ionic-padding",
                            name: "payment_mode",
                            value: "paypal",
                            onClick: _cache[0] || (_cache[0] = ($event: any) => ($data.paymentMode='paypal')),
                            "label-placement": "end"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, {
                                class: "ion-text-wrap",
                                style: {"padding":"10px"}
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Carta di credito tramite circuito PayPal (con iscrizione subordinata alla verifica dei requisiti)")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_item, {
                        lines: "none",
                        class: "ionic-padding"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_radio, {
                            justify: "start",
                            modelValue: $data.paymentMode,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($data.paymentMode) = $event)),
                            name: "payment_mode",
                            value: "bank_transfer",
                            onClick: _cache[2] || (_cache[2] = ($event: any) => ($data.paymentMode='bank_transfer')),
                            "label-placement": "end"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, {
                                class: "ion-text-wrap",
                                style: {"padding":"10px"}
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Bonifico bancario (con iscrizione subordinata alla verifica dei requisiti e del pagamento)")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (!$data.paypalButtonsCreated && $data.paymentMode === 'paypal')
            ? (_openBlock(), _createBlock(_component_ion_button, {
                key: 1,
                shape: "round",
                expand: "block",
                size: "default",
                onClick: $options.createPaypalButton,
                style: {"margin":"15px"}
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Procedi al pagamento ")
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true),
          ($data.paymentMode === 'bank_transfer')
            ? (_openBlock(), _createBlock(_component_ion_item, { key: 2 }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_text, null, {
                    default: _withCtx(() => [
                      _hoisted_2,
                      _hoisted_3,
                      _hoisted_4,
                      _hoisted_5,
                      _hoisted_6
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          ($data.paymentFeedback.status === 'COMPLETED')
            ? (_openBlock(), _createBlock(_component_ion_item, {
                key: 3,
                color: "success"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_label, null, {
                    default: _withCtx(() => [
                      _createTextVNode("Pagamento completato")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_icon, {
                    icon: $setup.checkmarkCircleOutline,
                    slot: "end"
                  }, null, 8, ["icon"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          ($data.paymentFeedback.status && $data.paymentFeedback.status !== 'COMPLETED')
            ? (_openBlock(), _createBlock(_component_ion_item, {
                key: 4,
                color: "danger"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_label, null, {
                    default: _withCtx(() => [
                      _createTextVNode("Pagamento rifiutato")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_icon, {
                    icon: $setup.closeCircleOutline,
                    slot: "end"
                  }, null, 8, ["icon"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          ($data.paymentFeedback.status !== 'COMPLETED')
            ? (_openBlock(), _createElementBlock("div", _hoisted_7))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}